import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('sharedContactDB', {
  version: 1,
  key: 'id',
  expireDuration: 2 * 24 * 60 * 60 * 1000, // 만료 기간 2일.
  skipPreload: false,
})

export default dataDB
